export const TOKEN_STORAGE_KEY = 'chianti_token';
export const REMENBER_PASSWORD_SWITCH_STORAGE_KEY = 'remember_password';
import { i18n } from '@/i18n';

export const MAX_NUMBER = Math.pow(2, 31) - 1;

export const TAG_TYPE = {
  male: 'success',
  female: 'warning',
  unknown: 'info',
  init: 'info',
  completed: 'success',
  applied: 'warning',
  refunding: 'danger',
  cancelled: 'info',
  closed: 'info',
  pending: 'warning',
  shipped: '',
  received: 'success',
  draft: 'info',
  published: 'success',
  success: 'success',
  fail: 'danger',
  failed: 'danger',
  delay: 'pending',
  expired: 'info',
  actived: '',
  will_start: 'warning',
  business: 'success',
  retail: 'warning',
  individual: 'info',
  rejected: 'danger',
  by_agent: 'success',
  by_self: 'warning',
  pavillon: 'success',
  ticket_event: 'warning',
  explore: '',
  merchant_list: 'success',
  list_with_image: 'warning',
  video_list: 'info',
  image: '',
  requested: 'warning',
  cashback: 'warning',
}

export const PAGE_TYPE = {
  StaticPage: '静态页面',
  PresetPage: '内置页面'
}

export const PAGE_STATUS = ['draft', 'published']

export const CONTENT_TYPES = [
  'image',
  'video',
  'audio',
  'text',
  'xml',
  'json',
  'pdf',
  'sheet'
]

export const BANNER_PAGE_POSITIONS = [
  'event'
]

export const BANNER_KINDS = [
  'web_link',
  'image',
  'mp_link'
]

export const COMMERCIAL_DOCUMENT_KIND = {
  topup: i18n.t('plutus_entries.commercial_document_kind_map.topup'),
  withdraw: i18n.t('plutus_entries.commercial_document_kind_map.withdraw'),
  transfer: i18n.t('plutus_entries.commercial_document_kind_map.transfer'),
  pay_with_qr_code: i18n.t('plutus_entries.commercial_document_kind_map.pay_with_qr_code'),
  cashback: i18n.t('plutus_entries.commercial_document_kind_map.cashback'),
  create_red_packet: i18n.t('plutus_entries.commercial_document_kind_map.create_red_packet'),
  receive_red_packet: i18n.t('plutus_entries.commercial_document_kind_map.receive_red_packet'),
  red_packet_expire: i18n.t('plutus_entries.commercial_document_kind_map.red_packet_expire'),
  order_ticket: i18n.t('plutus_entries.commercial_document_kind_map.order_ticket'),
  electricity: i18n.t('plutus_entries.commercial_document_kind_map.electricity'),
  airtime: i18n.t('plutus_entries.commercial_document_kind_map.airtime'),
}

export const TEST_ACCOUNT_FOR_APPLE = ["00000000", "11111111"]

export const DAY_OF_WEEK_OPTIONS = {
  0: i18n.t('dayOfWeek.sunday'),
  1: i18n.t('dayOfWeek.monday'),
  2: i18n.t('dayOfWeek.tuesday'),
  3: i18n.t('dayOfWeek.wednesday'),
  4: i18n.t('dayOfWeek.thursday'),
  5: i18n.t('dayOfWeek.friday'),
  6: i18n.t('dayOfWeek.saturday'),
}
